/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const LOCAL_STORAGE_LOGIN_ERROR = "custom-login-error";
export const LOCAL_STORAGE_DOMAIN_HINT_NAME = "liam-domain-hint";
export const LOCAL_STORAGE_TIMEOUT_OPT_IN = "timeout-was-actived";
export const LOCAL_STORAGE_LAST_CONNECTION = "last-connection";
